import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const payloadSchema = z.object({});

export const runStartedDefinitions = {
    run_started: defineInvisible('run_started', {
        disposition: 'invisible',
        schema: payloadSchema,
        malformed: { kind: 'skip' },
        evidence(_payload, occurrence) {
            if (occurrence.committed === null) {
                return null;
            }
            return {
                kind: 'run_started',
                eventId: occurrence.committed.id,
                occurredAtMs: Date.parse(occurrence.committed.created_at),
            };
        },
    }),
} as const;

export const runStartedContractFixtures = {
    valid: {
        type: 'run_started',
    },
    malformed: null,
} as const;
